<template>
  <modal :show="show" @close="close">
    <div id="invalid-id-modal" slot="header" class="modal-header">
      <h5 class="modal-title">Patient Association Application</h5>
      <button id="btn-invalid-id-ok" type="button" class="close" @click="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div slot="body">
      The {{ label }} {{ barcode }} (entered: {{ raw }}) is unknown. Please contact Technical Support.
    </div>
  </modal>
</template>

<script>
import Modal from "../Modal";

import { PATIENT, VENTILATOR, ERROR, PATIENT_NUMBER, VENTILATOR_SERIAL, ERROR_TEXT } from "../../utils/constants";

export default {
  name: "InvalidIDModal",
  components: {
    modal: Modal
  },
  props: ["show", "type", "barcode", "raw"],
  computed: {
    label() {
      switch (this.type) {
        case PATIENT:
          return PATIENT_NUMBER;
        case VENTILATOR:
          return VENTILATOR_SERIAL;
        case ERROR:
          return ERROR_TEXT;
      }
      return "";
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped></style>
